import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a91896f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "highlight" }
const _hoisted_4 = { class: "head" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "tag" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top_icon" }, null, -1))

import { storeToRefs } from 'pinia';
import { Ref, ref } from 'vue';
import { useGame } from '@/store';
import Record from '@ui/components/Record.vue';
import Navigator from '@ui/components/Navigator.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Result',
  setup(__props) {

const { selectedCharacter } = storeToRefs(useGame());
const isScrollToTop: Ref<boolean> = ref(true);
const scrollTarget: Ref<HTMLElement | null> = ref(null);

const handleScroll = (e: Event) => {
  isScrollToTop.value = (e.target as HTMLInputElement).scrollTop === 0;
};
const scrollToTop = () => {
  if (scrollTarget.value) {
    scrollTarget.value['scrollTop'] = 0;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "scrollTarget",
    ref: scrollTarget,
    class: "result",
    onScroll: handleScroll
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('RESULT__EVENT_TITLE__LEFT')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('RESULT__EVENT_TITLE__RIGHT')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        src: _unref(selectedCharacter)?.headUrl,
        alt: ""
      }, null, 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(selectedCharacter)?.name), 1),
    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(`RESULT__PARTITION__TAG_${_unref(selectedCharacter)?.partition}`)), 1),
    _createVNode(Record),
    _createVNode(Navigator),
    _withDirectives(_createElementVNode("div", {
      class: "scroll_btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToTop()))
    }, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('RESULT__BUTTON__TO_TOP')), 1),
      _hoisted_8
    ], 512), [
      [_vShow, !isScrollToTop.value]
    ])
  ], 544))
}
}

})